import { useContext, useEffect, useState, useRef } from "react"
import { AppContext } from "../App"
import { PiBuildingOfficeBold, PiStudent } from "react-icons/pi";
import { formatMoney, formatMoneyShorten } from "../Helpers";
import { FaChalkboardTeacher } from "react-icons/fa";
import { SiGoogleclassroom } from "react-icons/si";
import { IoIosPeople, IoMdHeartHalf } from "react-icons/io";
import { getInlineLoader } from "../Helpers";
import TabbedView from "../components/TabbedView";
import {
  STR_FIND_MATCH,
  STR_LATEST_ARTICLES,
  STR_MENU_ARTICLES,
  STR_MENU_DATING,
  STR_MENU_STORIES,
  STR_MENU_UTILITIES,
  STR_MORE_ARTICLES,
  STR_NO_DATA_FOUND,
  STR_NOTIFICATIONS,
  STR_PURCHASE_SUBSCRIPTION_PACKAGE
} from "../Strings";
import OneNotification from '../ones/OneNotification';
import SubscriptionExpiredWidget from '../ones/SubscriptionExpiredWidget';
import LoginView from '../views/LoginView';


export default function Notifications(props) {

  const appContext = useContext(AppContext);

  /* Place states here */
  const [ready, setReady] = useState(false);

  async function init() {
    //run initializations here
    setReady(false);
    await Promise.all(
      [
				appContext.getCurrentUserData(),
			]
    )
    setReady(true);
  }

  useEffect(() => {
    init();
  }, [])



  if(appContext.auth && appContext.currentUserData) {
    if (ready) {
      return (
        <div
          style={{
            width: "100%",
            height: "100%",
            overflow: "scroll",
            paddingBottom: "80px",
          }}
          className="mNoScrollBar"
        >
          <div className="container">
  
            <h6 className="mSectionTitle">
              {STR_NOTIFICATIONS[appContext.language]}
            </h6>
  
            {
              (appContext.currentUserData && JSON.parse(appContext.currentUserData.notifications).length > 0) ?
                JSON.parse(appContext.currentUserData.notifications).reverse().map((item, i) => {
                  return (
                    <OneNotification key={i} data={item} />
                  )
                })
                :
                <h6>
                  {STR_NO_DATA_FOUND[appContext.language]}
                </h6>
            }
          </div>
        </div>
      )
  
    } else {
      return (
        <div
          className="mSupportLoading"
          style={{
            width: "100%",
            height: "100%",
          }}
        >
          {getInlineLoader()}
        </div>
      );
    }
  } else {
    return <LoginView/>
  }


}